"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreTreemap = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreTreemap = /** @class */ (function (_super) {
    tslib_1.__extends(CoreTreemap, _super);
    function CoreTreemap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreTreemap.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "treemap" }, this.props));
    };
    return CoreTreemap;
}(react_1.default.PureComponent));
exports.CoreTreemap = CoreTreemap;
//# sourceMappingURL=CoreTreemap.js.map